module.exports = __webpack_public_path__ + "img/logo.3466926b.png";